(function () {
  'use strict';

  /**
   * @typedef {import('./types').PopupScope} PopupScope
   */

  angular.module('popup').controller('popupCtrl', popupCtrl);

  popupCtrl.$inject = ['$mdDialog', '$scope'];

  /**
   * @param {angular.material.IDialogService} $mdDialog
   * @param {PopupScope} $scope
   */
  function popupCtrl($mdDialog, $scope) {
    var vm = this;

    vm.loaded = true;
    vm.model = $scope.model;
    vm.data = $scope.data;
    vm.submitIsDisabled = false;

    // this is important for e.g. unit.popup.change.price.html
    // to be able to make calculations in directives
    $scope.Math = window.Math;

    vm.onSubmit = function () {
      $scope.object = vm.model;
      $scope.onSubmit({ object: $scope.object });
      vm.submitIsDisabled = true;
      vm.closeDialog();
    };

    vm.closeDialog = function () {
      $mdDialog.hide();
      $scope.onBack();
    };

    vm.angucompleteClearInput = function (event, elementId) {
      $scope.$broadcast('angucomplete-alt:clearInput', elementId);
    };
  }
})();
